import { render, staticRenderFns } from "./ChangeIconBtn.vue?vue&type=template&id=606a07a6"
import script from "./ChangeIconBtn.vue?vue&type=script&lang=js"
export * from "./ChangeIconBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports